// Resolve the backend origin at runtime (same logic as services/api.js).
// Production builds do not carry REACT_APP_BACKEND_URL (frontend/.env is
// excluded by /app/.dockerignore), so never read it directly outside localhost.
export const getBackendUrl = () => {
  const currentHost = window.location.hostname;
  if (currentHost === 'localhost' || currentHost === '127.0.0.1') {
    return process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
  }
  return window.location.origin;
};
